import { Component, OnInit, ViewChild } from '@angular/core';
import { DashboardService } from '../../services/dashboard.service';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms'
import { ValidationsService } from '../../services/common/validations.service';
declare var $: any;

@Component({
  selector: 'app-exam-corner',
  templateUrl: './exam-corner.component.html',
  styleUrls: ['./exam-corner.component.scss']
})
export class ExamCornerComponent implements OnInit {

  @ViewChild('paginatorRef', { static: true }) paginatorRef: any;

  isLoading = true;
  isTableDataLoading = true;

  optionForm: FormGroup;

  filtersData;
  paginationEvent;

  getExamListPostData = {
    filter: '',
    stream_name: '',
    mode: '',
    type: '',   // application status
    recognized: '',
    search: '',
    // location: '',
    offset: 0
  };

  examListApiResponse;
  examListFromApi;

  //
  collegeListApiResponse;
  examName;
  isCollegeFound;

  // Exam bucket
  examBucket = [];
  subscribedExams = [];
  unsubscribedExams = [];
  viewSubscribedExamsList = [];
  viewSubscribedClicked;

  // Pagination
  noOfPages;

  constructor(private formBuilder: FormBuilder, private validationService: ValidationsService, private dashboardService: DashboardService) { }

  ngOnInit() {

    this.optionForm = this.formBuilder.group({
      location: ['']
    });

    this.optionForm.get('location').valueChanges.subscribe(optedValue => {
      // this.getExamListPostData.location = optedValue;
      this.getExamListPostData.offset = 0;
      this.getExamList();
    });

    this.getExamListPostData.filter = 'No';

    this.getExamFiltersData();

    this.getExamList();

  }


  getExamFiltersData() {
    this.dashboardService.getExamFiltersData().subscribe(response => {
      this.isLoading = false;
      if (response.status == true && response.statusCode == 200) {
        this.filtersData = response.data;
      }
    });
  }


  setFilterAndGetExamList() {
    this.getExamListPostData.filter = 'Yes';
    this.getExamListPostData.offset = 0;
    // this.paginationEvent.first = 0;
    // this.paginationEvent.page = 0;
    this.getExamList();
  }


  getExamList() {
    // console.log('ref', this.paginatorRef);
    if (this.viewSubscribedClicked == true) {
      this.viewSubscribedClicked = false;
    }
    this.isTableDataLoading = true;
    // if (this.getExamListPostData.mode != null || this.getExamListPostData.recognized != null
    //   || this.getExamListPostData.search != null || this.getExamListPostData.stream_name != null 
    // || this.getExamListPostData.type != null) {
    //   this.getExamListPostData.filter = 'Yes';
    // }
    this.dashboardService.getExamsList(this.getExamListPostData).subscribe(response => {
      // this.isLoading = false;
      this.isTableDataLoading = false;
      console.log(response);

      if (response.status == true && response.statusCode == 200) {
        this.examListApiResponse = response.data;
        this.examListFromApi = response.data.examList;
        this.noOfPages = response.data.count;

        (response.data.examList).forEach(element => {
          if (element.subscribed != null && this.examBucket.indexOf(element.mep_id) === -1 && this.unsubscribedExams.indexOf(element.mep_id) === -1) {
            this.examBucket.push(element.mep_id);
            this.subscribedExams.push(element.mep_id);
          }
        });
      }
      console.log(this.examBucket);
    });
    // this.paginatorRef.changePage(0);
  }


  viewCollegeList(examShortForm) {
    this.examName = examShortForm;

    this.dashboardService.getCollegeListForExam({ short_form: examShortForm }).subscribe(response => {
      console.log(response);
      if (response.status == true && response.statusCode == 200) {
        this.isCollegeFound = true;
        this.collegeListApiResponse = response.data;
        $('#collegeListModal').modal('show');
      }
      if (response.status == false && response.statusCode == 200) {
        this.isCollegeFound = false;
        $('#collegeListModal').modal('show');
      }
    });
  }

  addToBucket(examMepId, checkedStatus) {
    if (checkedStatus == false) {
      this.subscribedExams.splice(this.subscribedExams.indexOf(examMepId), 1);
      if (this.unsubscribedExams.indexOf(examMepId) === -1) {
        this.unsubscribedExams.push(examMepId);
      }
      // UI
      this.examBucket.splice(this.examBucket.indexOf(examMepId), 1);
    }
    else {
      if (this.unsubscribedExams.indexOf(examMepId) !== -1) {
        this.unsubscribedExams.splice(this.unsubscribedExams.indexOf(examMepId), 1);
      }
      this.subscribedExams.push(examMepId);
      // UI
      this.examBucket.push(examMepId);
    }
    console.log('sub--', this.subscribedExams);
    console.log('unsub--', this.unsubscribedExams);

  }

  saveExams() {
    // console.log('save');
    // console.log('subs - ', this.subscribedExams);
    // console.log('unsubs - ', this.unsubscribedExams);

    this.dashboardService.addExamsToPartnerBucket({ subscribe: this.subscribedExams, unsubscribe: this.unsubscribedExams }).subscribe(response => {
      if (response.status == true && response.statusCode == 200) {
        console.log(response);
      }
    });
  }

  viewSubscribedExams() {
    this.viewSubscribedClicked = !this.viewSubscribedClicked;

    if (this.viewSubscribedClicked == true) {
      this.dashboardService.getSubscribedExamsList().subscribe(response => {
        if (response.status == true && response.statusCode == 200) {
          this.examListFromApi = response.data.subscriptionList;
          this.noOfPages = 0;

          (response.data.subscriptionList).forEach(element => {
            if (element.subscribed != null && this.examBucket.indexOf(element.mep_id) === -1 && this.unsubscribedExams.indexOf(element.mep_id) === -1) {
              this.examBucket.push(element.mep_id);
              this.subscribedExams.push(element.mep_id);
            }
          });
        }
      });
      //   this.examListFromApi = [];
      //   (this.examListApiResponse.examList).forEach(element => {
      //     if (element.subscribed != null) {
      //       this.examListFromApi.push(element);
      //     }
      //   });
      //   this.noOfPages = this.examListFromApi.length;
    }
    else {
      this.getExamList();
    }

  }


  paginate(event) {
    this.paginationEvent = event;
    // console.log(event);
    // console.log(p);
    this.getExamListPostData.filter = 'Yes';
    this.getExamListPostData.offset = (event.first);
    // event.first = 0;
    this.getExamList();
  }

}
